import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[avanoTabButtonBar]'
})
export class TabButtonBarDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
